export const FETCH_IMPORTS = 'FETCH_IMPORTS';
export const FETCH_IMPORTS_START = `${FETCH_IMPORTS}_START`;
export const FETCH_IMPORTS_SUCCESS = `${FETCH_IMPORTS}_SUCCESS`;
export const FETCH_IMPORTS_ERROR = `${FETCH_IMPORTS}_ERROR`;
export const FETCH_IMPORT = 'FETCH_IMPORT';
export const FETCH_IMPORT_START = `${FETCH_IMPORT}_START`;
export const FETCH_IMPORT_SUCCESS = `${FETCH_IMPORT}_SUCCESS`;
export const FETCH_IMPORT_ERROR = `${FETCH_IMPORT}_ERROR`;
export const FETCH_ALL_IMPORTS = 'FETCH_ALL_IMPORTS';
export const FETCH_ALL_IMPORTS_START = `${FETCH_ALL_IMPORTS}_START`;
export const FETCH_ALL_IMPORTS_SUCCESS = `${FETCH_ALL_IMPORTS}_SUCCESS`;
export const FETCH_ALL_IMPORTS_ERROR = `${FETCH_IMPORTS}_ERROR`;
export const DELETE_IMPORT = 'DELETE_IMPORT';
export const CLEAR_IMPORTS = 'CLEAR_IMPORTS';
export const SET_STATUS_UPDATE = 'SET_STATUS_UPDATE';
export const FETCH_AMOUNT_APPENDICES = 'FETCH_AMOUNT_APPENDICES';
export const FETCH_AMOUNT_APPENDICES_START = `${FETCH_AMOUNT_APPENDICES}_START`;
export const FETCH_AMOUNT_APPENDICES_SUCCESS = `${FETCH_AMOUNT_APPENDICES}_SUCCESS`;
export const FETCH_AMOUNT_APPENDICES_ERROR = `${FETCH_AMOUNT_APPENDICES}_ERROR`;
export const FETCH_FAILED_ROWS_FILE = 'FETCH_FAILED_ROWS_FILE';
//# sourceMappingURL=actionTypes.js.map